module.exports = __webpack_public_path__ + "static/media/training_pipeline.6dee3063.png";